import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { FormattedMessage } from "react-intl"

import { formatDate } from "../../../../util/format"
import { Tooltip } from "../../../common"

import { selectIsFreemiumUser } from "../../../../redux/selectors/selectIsFreemiumUser"

import { useTokens } from "../../../../hooks/useTokens"

const AddMoreLink = ({ to = "/buy-more" }) => (
  <b>
    <Link to={to}>
      <FormattedMessage id="common.addMoreHere" />
    </Link>
  </b>
);

const UpgradeToPremiumLink = ({ to = "/choose-pricing" }) => (
  <b>
    <Tooltip tooltip={<FormattedMessage id="common.addMoreAndUpgradeTooltip" />} >
      <Link to={to}>
          <FormattedMessage id="common.addMoreAndUpgrade" />
      </Link>
    </Tooltip>
  </b>
);

const FreemiumInfo = ({ creditsExpiringSoonText, uploadMoreCVsText, outOfTokens }) => (
  <div className="info">
    {!outOfTokens && (
      <p className="info__text">
        {uploadMoreCVsText}{" - "}<UpgradeToPremiumLink />
        <br />
        {creditsExpiringSoonText}
      </p>
    )}

    {outOfTokens && (
      <p className="info__text info__text">
        <b><FormattedMessage id="message.youreOutOfTokens" /></b>
        <br />
        <FormattedMessage id="message.waitForNextMonthOr" />
        {" - "}
        <UpgradeToPremiumLink />
      </p>
    )}
  </div>
);

const Info = () => {
  const cvAnalysisTokenCost = useSelector((state) => state.config.tokenCosts.CV_ANALYSIS);
  const isFreemiumUser = useSelector(selectIsFreemiumUser);

  const { availableTokens, cvTokensExpiringSoon, earliestExpiryDate } = useTokens({});

  const outOfTokens = availableTokens <= 0;
  const hasExpiringTokens = cvTokensExpiringSoon > 0;

  const uploadMoreCVsText = availableTokens >= cvAnalysisTokenCost && (
    <FormattedMessage
      id="message.uploadMoreCVs"
      values={{ cvCredits: Math.floor(availableTokens / cvAnalysisTokenCost) }}
    />
  );

  const creditsExpiringSoonText = cvTokensExpiringSoon > 0 && (
    <>
      <b><FormattedMessage id='message.creditsExpiringSoon.reminder' /></b>
      {' '}
      <FormattedMessage
        id="message.creditsExpiringSoon"
        values={{ 
          tokens: cvTokensExpiringSoon,
          earliestExpiryDate: formatDate(earliestExpiryDate)
        }}
      />
    </>
  );

  if (isFreemiumUser) {
    return (
      <FreemiumInfo
        creditsExpiringSoonText={creditsExpiringSoonText}
        uploadMoreCVsText={uploadMoreCVsText}
        outOfTokens={outOfTokens}
      />
    )
  }

  if (outOfTokens) {
    return (
      <div className="info">
        <p className="info__text info__text--highlight">
          <FormattedMessage id="message.youHaveUsedYourTokens" />{" "}<AddMoreLink />
        </p>
      </div>
    )
  }

  return (
    <div className="info">
      <p className="info__text">
        {uploadMoreCVsText}{" - "}<AddMoreLink />

        {hasExpiringTokens && (
          <>
            <br />{creditsExpiringSoonText}
          </>
        )}
      </p>
    </div>
  )
}

export default Info
